<script>
    import Button from "./button.svelte";
    import { show } from "./store.js";
    let close;
    show.subscribe((value) => {
        close = value;
    });
    let contact_us = [
        {
            icon: "/images/submit_your_plan/location_icon.svg",
            details: "44 East 3rd Ave, San Mateo, CA 94401",
        },
        {
            icon: "/images/submit_your_plan/phone_icon.svg",
            details: "512 537 5153",
        },
        {
            icon: "/images/submit_your_plan/mail.svg",
            details: "<span style='color:#3C88C3;'> hello@automason.ai </span>",
        },
    ];
    let options = [
        "SINGLE TRADE PRICING",
        "PRICING FOR RESIDENTIAL & COMMERCIAL ESTIMATES",
        "PRICING FOR INDUSTRIAL ESTIMATES",
        "DEDICATED CONSTRUCTION ESTIMATOR",
    ];
    let submitted=0;
    let success_msg;
    let email_err=0;
    let res_message;
    let form_data = {
        name: "",
        email: "",
        project_scope: "",
        description: "",
    };
    function contactRequest() {
        const { name, email, project_scope, description } = form_data;
        rpcjs.API.automason
            .save_contact_request(name, email, project_scope, description)
            .then(function (res) {
                // alert(res.message);
                success_msg=res.message;
                submitted=1;
            })
            .catch(function (res) {
                // alert(res.message);
                res_message=res.message;
                email_err=1;
            });
    }
    $: console.log(form_data);
</script>

<div class="desktop">
    {#if close}
        <div class="modal">
            <div class="main-div">
                <div class="box-wrraper">
                    <div class="image_part">
                        <div class="image-wrraper">
                            <img
                                src="/images/submit_your_plan/background.png"
                                alt=""
                                width="100%"
                            />
                        </div>
                        <div class="get-in-touch-text">
                            <img
                                src="/images/submit_your_plan/get_in_touch.svg"
                                alt=""
                            />
                        </div>
                        <div class="contact-us-card">
                            {#each contact_us as contact}
                                <div class="card-lines">
                                    <div class="contact-icon">
                                        <img
                                            src={contact.icon}
                                            alt=""
                                            width="100%"
                                        />
                                    </div>
                                    <div class="contact-text">
                                        <p style="font-weight: 500; margin: 0;">
                                            {@html contact.details}
                                        </p>
                                    </div>
                                </div>
                            {/each}
                        </div>
                    </div>
                    <div>
                        <div class="form_part">
                            <div
                                class="close-btn"
                                on:click={(e) => {
                                    if (close != 0) {
                                        close = 0;
                                    }
                                    console.log("close", close);
                                }}
                            >
                                <div class="close-position">
                                    <div class="exit-icon">
                                        <img
                                            src="/images/home_page/close.svg"
                                            alt=""
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="submit-project-title">
                                <img
                                    src="/images/submit_your_plan/submit_project.svg"
                                    alt=""
                                />
                            </div>
                            {#if submitted!=1}
                            <form
                                class="form-section"
                                on:submit|preventDefault={contactRequest}
                            >
                                <input
                                    class="input"
                                    type="text"
                                    id="name"
                                    name="name"
                                    placeholder="Full Name..."
                                    bind:value={form_data.name}
                                />
                                <br />
                                <input
                                    style="top:19.8vw"
                                    class="input"
                                    type="text"
                                    id="email"
                                    name="Email"
                                    placeholder="Email..."
                                    bind:value={form_data.email}
                                />
                                <br />
                                {#if email_err==1}
                                <span 
                                style="color: red;
                                text-decoration: underline;
                                margin-left: 8vw;
                                position: relative;
                                top: 21.5vw;
                                font-size: 0.75vw;">
                                {res_message}
                            </span>
                                {/if}
                                <select
                                    class="form-select"
                                    bind:value={form_data.project_scope}
                                    required
                                >
                                    <option value="" disabled selected
                                        >Project Scope</option
                                    >
                                    {#each options as option}
                                        <option value={option}>
                                            {option}
                                        </option>
                                    {/each}
                                </select>
                                <textarea
                                    type="text"
                                    placeholder="Describe your Request..."
                                    bind:value={form_data.description}
                                />
                                <div class="sub-bnt">
                                    <Button
                                        border_radius="0.625vw"
                                        padding="1.042vw 3.073vw"
                                        title="Submit"
                                        me="2"
                                        btnStyle="submit_btn"
                                        px="0"
                                    />
                                </div>
                            </form>
                            {:else}
                            <div class="smsg">
                                <h1 style="font-size:3.05vw;">{success_msg}</h1>
                                <h1 style="font-size:3.05vw;">We will reach back soon.</h1>
                            </div>
                            {/if}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    {/if}
</div>

<div class="mobile">
    {#if close}
        <div class="modal">
            <div class="main-div">
                <div class="box-wrraper">
                    <div class="image_part">
                        <div class="image-wrraper">
                            <img
                                src="/images/submit_your_plan/background.png"
                                alt=""
                                width="100%"
                            />
                        </div>
                        <div class="get-in-touch-text">
                            <img
                                src="/images/submit_your_plan/get_in_touch.svg"
                                alt=""
                            />
                        </div>
                        <div class="contact-us-card">
                            <div class="card-lines">
                                <div
                                    class="contact-icon"
                                    style="padding-top: 2vw;"
                                >
                                    <img
                                        src="/images/submit_your_plan/location_icon.svg"
                                        alt=""
                                        width="100%"
                                    />
                                </div>
                                <div
                                    class="contact-text"
                                    style="margin-bottom: 2.374vw;"
                                >
                                    <p
                                        style=" font-size:3.028vw; font-weight: 500; margin: 0;"
                                    >
                                        44 East 3rd Ave, San Mateo, CA 94401
                                    </p>
                                </div>
                            </div>
                            <div class="card-lines">
                                <div class="contact-icon">
                                    <img
                                        src="/images/submit_your_plan/phone_icon.svg"
                                        alt=""
                                        width="100%"
                                    />
                                </div>
                                <div
                                    class="contact-text"
                                    style="padding-top: 1vw;"
                                >
                                    <p
                                        style=" font-size:3.028vw; font-weight: 500; margin: 0;"
                                    >
                                        512 537 5153
                                    </p>
                                </div>
                            </div>
                            <div class="card-lines">
                                <div
                                    class="contact-icon"
                                    style="padding-top: 0.7vw;"
                                >
                                    <img
                                        src="/images/submit_your_plan/mail.svg"
                                        alt=""
                                        width="100%"
                                    />
                                </div>
                                <div class="contact-text">
                                    <address>
                                        <a
                                            style=" font-size:3.028vw; font-weight: 500; margin: 0; color:#3C88C3;"
                                            href="mailto:hello@automason.ai"
                                        >
                                            hello@automason.ai
                                        </a>
                                    </address>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form_part">
                        <div
                            class="close-btn"
                            on:click={(e) => {
                                if (close != 0) {
                                    close = 0;
                                }
                                console.log("close", close);
                            }}
                        >
                            <div class="close-position">
                                <div class="exit-icon">
                                    <img
                                        src="/images/home_page/close.svg"
                                        alt=""
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="submit-project-title">
                            <img
                                src="/images/submit_your_plan/submit_project.svg"
                                alt=""
                            />
                        </div>
                        {#if submitted!=1}
                        <form
                            class="form-section"
                            on:submit|preventDefault={contactRequest}
                        >
                            <input
                                class="input"
                                type="text"
                                id="name"
                                name="name"
                                placeholder="Full Name..."
                                bind:value={form_data.name}
                            />
                            <br />
                            {#if email_err==1}
                            <span style="
                            color: red;
                            text-decoration: underline;
                            margin-left: 8vw;
                            font-size: 2.27vw;
                            top: 47vw;
                            position: relative;
                        ">{res_message}</span>
                            {/if}
                            <input
                                style="top:42.59vw"
                                class="input"
                                type="text"
                                id="email"
                                name="Email"
                                placeholder="Email..."
                                bind:value={form_data.email}
                            />
                            <br />
                            <select
                                class="form-select"
                                bind:value={form_data.project_scope}
                                required
                            >
                                <option value="" disabled selected>Project Scope</option>
                                {#each options as option}
                                    <option value={option}>
                                        {option}
                                    </option>
                                {/each}
                            </select>
                            <textarea
                                type="text"
                                placeholder="Describe your Request..."
                                bind:value={form_data.description}
                            />
                            <div class="sub-bnt">
                                <Button
                                    border_radius="1.916vw"
                                    padding="3.194vw 10.194vw"
                                    title="Submit"
                                    me="2"
                                    btnStyle="submit_btn_mobile"
                                    px="0"
                                />
                            </div>
                        </form>
                        {:else}
                        <div class="smsg-mob" style="text-align: center;
                margin-top: 53vw;">
                    <h1 style="font-size: 7.125vw;">{success_msg}</h1>
                    <h1 style="font-size: 7.125vw;">We will reach back soon.</h1>
                </div>
                {/if}
                    </div>
                </div>
            </div>
        </div>
    {/if}
</div>

<style>
    .modal {
        display: block;
        position: fixed;
        z-index: 6;
        top: 0vw;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        left: 0;
    }
        .smsg{
            text-align: center;
    font-family: 'Poppins';
    position: relative;
    top: 22vw;
    }
    .main-div {
        width: 91.7vw;
        height: 49.5vw;
        margin: auto;
        position: absolute;
        overflow: hidden;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
    .box-wrraper {
        display: flex;
        justify-content: space-between;
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: absolute;
        top: 0vw;
    }
    .image_part {
        width: 55vw;
        height: 100%;
    }
    .image-wrraper {
        width: 100%;
        height: 100%;
    }
    .form_part {
        background-color: #ff6d24;
        height: 100%;
        width: 40vw;
    }
    .get-in-touch-text {
        width: 13vw;
        position: absolute;
        top: 25vw;
        left: 6.5vw;
    }
    .get-in-touch-text img {
        width: 100%;
        height: 100%;
    }
    .contact-us-card {
        position: absolute;
        width: 22.365vw;
        border-radius: 1.042vw;
        background-color: white;
        display: flex;
        flex-direction: column;
        gap: 1.8vw;
        padding-top: 3.125vw;
        padding-bottom: 2.469vw;
        top: 29vw;
        left: 2.7vw;
    }
    .card-lines {
        display: flex;
        gap: 1.875vw;
        flex-direction: row;
        margin-left: 2.292vw;
    }
    .contact-icon {
        width: 1.406vw;
        height: 1.771vw;
    }
    .contact-text {
        width: 12.281vw;
    }
    .submit-project-title {
        width: 18vw;
        justify-content: center;
        position: absolute;
        left: 62.9vw;
        top: 7.5vw;
    }
    .submit-project-title img {
        width: 100%;
        height: 100%;
    }
    .form-section {
        position: absolute;
    }
    .input {
        width: 23.698vw;
        height: 3.456vw;
        border: 0.11vw solid white;
        background: transparent;
        color: white;
        border-radius: 0.3vw;
        position: absolute;
        top: 14vw;
        left: 8vw;
    }
    input[type="text"] {
        font-size: 0.833vw;
        font-weight: 400;
        font-family: "Poppins", sans-serif;
        padding-left: 1.771vw;
        background-color: transparent;
    }
    input:focus {
        outline: none;
    }
    input:focus::placeholder {
        color: transparent;
    }
    ::placeholder {
        color: white;
        font-size: 0.833vw;
        font-weight: 400;
        font-family: "Poppins", sans-serif;
    }
    .form-select {
        color: white;
        font-size: 0.833vw;
        font-weight: 400;
        font-family: "Poppins", sans-serif;
        position: absolute;
        top: 25.6vw;
        left: 8vw;
        width: 25.89vw;
        height: 4vw;
        padding-left: 1.7vw;
    }
    option {
        color: #000000;
    }
    select {
        background: url("/images/pricing/drop_down.svg");
        -webkit-appearance: none;
        background-size: 1vw;
        background-repeat: no-repeat;
        background-position: right 1.1vw center;
        border: 0.11vw solid white;
        margin-left: auto;
        margin-right: auto;
        justify-content: center;
        display: flex;
        border-radius: 0.3vw;
    }
    select:focus {
        background: url("/images/pricing/drop_up.svg");
        background-size: 1vw;
        background-repeat: no-repeat;
        background-position: right 1.1vw center;
        outline: none;
    }
    textarea {
        width: 24vw;
        height: 8.55vw;
        border: 0.11vw solid white;
        background: transparent;
        border-radius: 0.3vw;
        padding-left: 1.5vw;
        padding-top: 1vw;
        color: white;
        font-size: 0.833vw;
        font-weight: 400;
        font-family: "Poppins", sans-serif;
        position: absolute;
        top: 31.7vw;
        left: 8vw;
    }
    textarea::placeholder {
        background-color: transparent;
        color: white;
        font-size: 0.833vw;
        font-weight: 400;
        font-family: "Poppins", sans-serif;
    }
    textarea:focus {
        width: 23.8vw;
        height: 8.55vw;
        font-size: 0.833vw;
        font-weight: 400;
        font-family: "Poppins", sans-serif;
        outline: none;
        background-color: transparent;
        padding-left: 1.7vw;
        padding-top: 1vw;
    }
    textarea:focus::placeholder {
        color: transparent;
    }
    textarea::after {
        font-size: 0.833vw;
        font-weight: 400;
        font-family: "Poppins", sans-serif;
        padding-left: 1.771vw;
        background-color: transparent;
    }
    .sub-bnt {
        position: absolute;
        top: 43.66vw;
        left: 16.719vw;
    }
    .exit-icon {
        width: 1.3vw;
        height: 1.3vw;
    }
    .exit-icon img {
        width: 100%;
        height: 100%;
    }
    .close-position {
        position: absolute;
        right: 2vw;
        top: 2vw;
        cursor: pointer;
    }
    .desktop {
        display: block;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .modal {
            overflow-y: scroll;
        }
        .mobile {
            display: block;
        }
        .main-div {
            width: 92.757vw;
            height: 211.855vw;
            overflow: scroll;
            top: 110vw;
            /* height: 125.407vw; */
        }
        .box-wrraper {
            flex-direction: column-reverse;
        }
        .image_part {
            width: 92.757vw;
            height: 86.449vw;
        }
        .form_part {
            height: 125.407vw;
            width: 92.757vw;
        }
        .exit-icon {
            width: 4.3vw;
            height: 4.3vw;
        }
        .close-position {
            right: 4.439vw;
            top: 5.374vw;
        }
        .submit-project-title {
            width: 50.829vw;
            left: 50%;
            transform: translateX(-50%);
            top: 9.818vw;
        }
        .input {
            width: 69.64vw;
            height: 11.178vw;
            border: 0.39vw solid white;
            border-radius: 0.798vw;
            top: 25.636vw;
            left: 8.215vw;
        }
        input[type="text"] {
            font-size: 2.395vw;
            padding-left: 7vw;
        }
        ::placeholder {
            font-size: 2.395vw;
        }
        .form-select {
            font-size: 2.395vw;
            top: 59.38vw;
            left: 8.215vw;
            width: 78vw;
            height: 13vw;
            padding-left: 7vw;
        }
        select {
            background-size: 3.5vw;
            background-position: right 3.1vw center;
            border: 0.39vw solid white;
            border-radius: 0.798vw;
        }
        select:focus {
            background-size: 3.5vw;
            background-position: right 3.1vw center;
        }
        textarea {
            width: 70vw;
            height: 28.9vw;
            border: 0.39vw solid white;
            border-radius: 0.798vw;
            padding-left: 6.9vw;
            padding-top: 1.636vw;
            font-size: 2.395vw;
            top: 76.79vw;
            left: 8.215vw;
        }
        textarea::placeholder {
            font-size: 2.395vw;
        }
        textarea:focus {
            width: 70vw;
            height: 28.9vw;
            font-size: 2.395vw;
            padding-left: 6.9vw;
            padding-top: 1.636vw;
        }
        textarea::after {
            font-size: 2.395vw;
            padding-left: 6.9vw;
        }
        .sub-bnt {
            top: 111.79vw;
            left: 31vw;
        }
        .get-in-touch-text {
            width: 35.28vw;
            top: 133.946vw;
            left: 26.379vw;
        }
        .contact-us-card {
            width: 61.839vw;
            border-radius: 4.324vw;
            gap: 4.787vw;
            padding-top: 9.946vw;
            padding-bottom: 7.383vw;
            top: 146.967vw;
            left: 15.353vw;
        }
        .card-lines {
            gap: 4.439vw;
            margin-left: 4.439vw;
        }
        .contact-icon {
            width: 4.206vw;
            height: 4.206vw;
        }
        .contact-text {
            width: 43.692vw;
        }
    }
    /* @media screen and (max-height: 1024px) {

    } */
</style>
